import React from 'react';

export default function EventAdminHistory({ logs }) {
  //TODO
  return <div>HISTORY</div>;
}
